export interface RevenueEntry {
  id: string;
  date: string;
  patient_name: string;
  patient_id?: string | null;
  patient?: { name: string | null } | null;
  observations?: string | null;
  entry_type: string;
  scheduled_by?: string | null;
  scheduled_by_profile_id?: string | null;
  scheduled_by_profile?: {
    nickname?: string | null;
    full_name: string;
  } | null;
  procedures: string;
  fee_amount: number;
  treatment_amount: number;
  received?: boolean;
  revenue_entry_items?: { active?: boolean | null }[] | null;
  payment_method?: string | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payment_methods?: any;
  created_at: string;
  updated_at: string;
}

export interface PaymentMethodEntry {
  method: string;
  installments: number;
}

export function getTypeColor(type: string): string {
  if (type === 'new') return 'bg-success/10 text-success';
  if (type === 'student') return 'bg-purple-500/10 text-purple-600';
  if (type === 'rent_commission') return 'bg-amber-500/10 text-amber-700';
  return 'bg-blue-500/10 text-blue-600';
}

export function getTypeLabel(type: string): string {
  if (type === 'new') return 'Novo';
  if (type === 'student') return 'Aluno';
  if (type === 'rent_commission') return 'Aluguel/Comissão';
  return 'Recorrência';
}

export function getPaymentMethodLabel(method: string | null): string {
  if (!method) return '-';
  const translations: Record<string, string> = {
    'credit_card': 'Cartão',
    'pix': 'PIX',
    'cash': 'Dinheiro',
    'debit_card': 'Débito',
    'bank_transfer': 'Transferência',
    'check': 'Cheque',
    'boleto': 'Boleto'
  };
  return translations[method] || method;
}

export function getFormattedPaymentMethods(entry: RevenueEntry): string {
  if (entry.payment_methods && Array.isArray(entry.payment_methods) && entry.payment_methods.length > 0) {
    return entry.payment_methods.map((pm: PaymentMethodEntry) => {
      const label = getPaymentMethodLabel(pm.method);
      const installments = pm.installments > 1 ? ` ${pm.installments}x` : '';
      return `${label}${installments}`;
    }).join(', ');
  }
  return getPaymentMethodLabel(entry.payment_method ?? null);
}
